import script from "./tour-match-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./tour-match-modal.vue?vue&type=script&setup=true&lang=js"

import "./tour-match-modal.vue?vue&type=style&index=0&id=2b2129a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b2129a3"]])

export default __exports__